import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-classica',
  templateUrl: './classica.component.html',
  styleUrls: ['./classica.component.css']
})
export class ClassicaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
